import { Form, Input } from 'antd';
import { observer } from 'mobx-react';
import React from 'react';
import styled from 'styled-components';

import type DocumentStore from 'stores/DocumentStore';
import DocumentWithMembershipStore from 'stores/DocumentWithMembershipStore';
import { isTaggable } from 'stores/Taggable';
import { normalizeInputSpace } from 'utils/String';

import MembersTable from '../DocumentFolderView/MembersTable/MembersTable';
import TagsManager from '../DocumentFolderView/TagsManager/TagsManager';
import { ModalForm, type SubmitCallback } from '../ModalForm';

export interface EditDocumentModalProps {
  open?: boolean;
  onClose?: () => void;
  document: DocumentStore<any, any>;
}

const CompactFormItem = styled(Form.Item)`
  margin-bottom: 18px;
`;

function EditDocumentModal({
  document,
  open,
  onClose,
}: EditDocumentModalProps) {
  const handleFormSubmit: SubmitCallback = async (values) => {
    await document.updateName(String(values.documentName).trimEnd());
  };

  return (
    <ModalForm
      formName="EditDocumentModalForm"
      cancelText="Done"
      modalStyles={{
        body: {
          maxHeight: '70vh',
          overflow: 'auto',
        },
      }}
      modalWidth={760}
      open={open}
      onClose={onClose}
      onSubmit={handleFormSubmit}
      okText="Save"
      takeFocusWhenOpening={false}
      title="Edit Properties"
    >
      <CompactFormItem
        label="Name"
        name="documentName"
        initialValue={document.data.name}
        normalize={(v) => normalizeInputSpace(v)}
        rules={[{ required: true }]}
      >
        <Input />
      </CompactFormItem>

      {document instanceof DocumentWithMembershipStore &&
        document.members.enabled && (
          <MembersTable parentDocument={document} title="Sharing" />
        )}

      {isTaggable(document) && (
        <TagsManager parentDocument={document} title="Tags" />
      )}
    </ModalForm>
  );
}

export default observer(EditDocumentModal);
